export default class PasswordUpdate {
  public oldPassword: string;
  public newPassword: string;

  constructor(oldPass: string, newPass: string) {
    this.oldPassword = oldPass;
    this.newPassword = newPass;
  }
}
